module.exports = __webpack_public_path__ + "img/cookie.58331f3d.png";